import React from 'react'
import styled from 'styled-components'
import {palette} from 'styled-tools'

import {formatNumber} from 'src/utils/numbers'

import {H3, H4, P, PSmall} from 'src/components/typography'
import {useCheckout} from 'src/context/CheckoutContext'

const Wrapper = styled.div`
  display: block;
  margin-bottom: 10px;
`

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  margin-bottom: 2px;
  border: 1px solid ${palette('black')};
  background-color: ${palette('white')};
`

const InfoBox = styled.div`
  padding: 28px 32px;
  border: 1px solid ${palette('black')};
  background-color: ${palette('white')};
`

const InfoLine = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
`

const PriceTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 60px;
  padding-top: 20px;
  border-top: 3px solid ${palette('red')};
`

export default function CartOverview(): JSX.Element {
  const {checkout} = useCheckout()

  return (
    <Wrapper>
      <TitleBox>
        <H4>Vörur í körfu</H4>
        <PSmall>
          {checkout?.quantity} {checkout?.quantity === 1 ? 'vara' : 'vörur'}
        </PSmall>
      </TitleBox>

      <InfoBox>
        {checkout?.subtotalPrice?.gross?.amount ? (
          <InfoLine>
            <P>Verð með VSK</P>
            <P>{formatNumber(checkout.subtotalPrice.gross.amount)} kr.</P>
          </InfoLine>
        ) : null}
        {checkout?.subtotalPrice?.tax?.amount ? (
          <InfoLine>
            <P>Þar af VSK</P>
            <P>{formatNumber(checkout?.subtotalPrice?.tax?.amount)} kr.</P>
          </InfoLine>
        ) : null}
        {!!checkout?.discount?.amount && (
          <InfoLine>
            <P>Afsláttur</P>
            <P color="red">
              {formatNumber(-1 * checkout?.discount?.amount)} kr.
            </P>
          </InfoLine>
        )}
        {!!checkout?.shippingPrice && !!checkout?.shippingMethod && (
          <>
            <InfoLine>
              <P>Sendingarkostnaður</P>
              <P>{formatNumber(checkout?.shippingPrice?.gross?.amount)} kr.</P>
            </InfoLine>
          </>
        )}
        {checkout?.totalPrice?.gross?.amount ? (
          <PriceTotal>
            <P color="black60">Samtals</P>

            <H3>{formatNumber(checkout?.totalPrice?.gross?.amount)} kr.</H3>
          </PriceTotal>
        ) : null}
      </InfoBox>
    </Wrapper>
  )
}
